import { select, call, put } from 'redux-saga/effects';
import api_v2 from 'services/api_v2';
import ReceiptActions from './ReceiptRedux';
import AppActions from './AppRedux';
import { AuthSelectors } from './AuthRedux';

export function* loadReceipts() {
  try {
    const token = yield select(AuthSelectors.selectToken);
    const api = api_v2(token);

    yield put(ReceiptActions.setReceiptsLoading(true));
    const tickets = yield call(api.getClosedTicketSByUser);
    yield put(ReceiptActions.setReceipts(tickets));
  } catch (e) {
    yield put(
      AppActions.setToast('There was problem loading receipts', 'danger')
    );
  } finally {
    yield put(ReceiptActions.setReceiptsLoading(false));
  }
}

export function* loadCurrentReceipt(actions) {
  try {
    const { receiptId } = actions;
    const token = yield select(AuthSelectors.selectToken);
    const api = api_v2(token);

    yield put(ReceiptActions.setCurrentReceiptLoading(true));
    const resp = yield call(api.getTicket, receiptId);

    yield put(ReceiptActions.setCurrentReceipt(resp));
  } catch (err) {
    yield put(
      AppActions.setToast('There was problem loading receipt', 'danger')
    );
  } finally {
    yield put(ReceiptActions.setCurrentReceiptLoading(false));
  }
}
